/** @format */

import Sync from "@croco/sync";
import * as dummy from "./mock-data.js";

class Accept {
  constructor(data) {
    this.checked = false;
    this.result = data;
  }
}

class SearchParam {
  constructor() {
    this.limit = 20;
    this.start_date = "";
    this.end_date = "";
    this.min_length = "";
    this.min_ratio = "";
    this.similarity = "";
  }

  clone() {
    let res = new SearchParam();
    for (const [k, v] of Object.entries(this)) {
      res[k] = v;
    }
    return res;
  }

  getQuery() {
    return Object.entries(this)
      .reduce((a, c) => {
        a.push(`${c[0]}=${encodeURIComponent(c[1])}`);
        return a;
      }, [])
      .join("&");
  }

  valid() {
    let res = [];
    const dateValid = (text) => {
      if (!text.match(/^(\d+)\/(\d+)\/(\d+)$/)) {
        return false;
      }
      const num = {
        y: Number(RegExp.$1),
        m: Number(RegExp.$2),
        d: Number(RegExp.$3),
      };
      const date = new Date(num.y, num.m - 1, num.d);
      const outputText = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()}`;
      const inputText = `${num.y}-${num.m}-${num.d}`;
      return inputText == outputText;
    };
    if (this.start_date != "") {
      if (!dateValid(this.start_date)) {
        res.push({
          prop: "start_date",
          error: ["有効な日付を入力してください"],
        });
      }
    }
    if (this.end_date != "") {
      if (!dateValid(this.end_date)) {
        res.push({
          prop: "end_date",
          error: ["有効な日付を入力してください"],
        });
      }
    }
    if (this.min_length != "") {
      if (!this.min_length.match(/^\d+$/)) {
        res.push({
          prop: "min_length",
          error: ["整数を入力してください。"],
        });
      }
    }
    if (this.min_ratio != "") {
      if (!this.min_ratio.match(/^\d+$/)) {
        res.push({
          prop: "min_ratio",
          error: ["整数を入力してください。"],
        });
      }
    }
    if (this.similarity != "") {
      if (!this.similarity.match(/^\d+$/)) {
        res.push({
          prop: "similarity",
          error: ["整数を入力してください。"],
        });
      }
    }
    return res;
  }
}

class AcceptService {
  /**
   * 解析結果からAcceptを生成
   * @param {object} results
   */
  static genAccepts(results) {
    return results.reduce((acc, cur) => {
      acc.push(new Accept(cur));
      return acc;
    }, []);
  }
}

class Mock {
  /**
   * 解析結果一覧
   *
   * @param {number} page 表示するページ番号
   * @param {number} limit 最大表示件数
   * @param {string} start_date 解析実行期間　開始
   * @param {string} end_date 解析実行期間　終了
   * @param {string} min_length 最高文字一致数　（下限）
   * @param {string} min_ratio 最高一致率　（下限）
   * @param {string} similarity 類似率　（下限）
   */
  requestAcceptHistories(
    page,
    limit,
    start_date,
    end_date,
    min_length,
    min_ratio,
    similarity
  ) {
    console.log({
      page,
      limit,
      start_date,
      end_date,
      min_length,
      min_ratio,
      similarity,
    });
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const accepts = similarity ? [] : dummy.accepts;
        const lastPage = Math.ceil(accepts.length / limit);
        resolve({
          success: true,
          pending: 1,
          unread: 2,
          pager: {
            items: accepts.slice((page - 1) * limit, page * limit),
            page: page,
            total: "999",
            last: lastPage,
            prev: page > 1 ? page - 1 : 1,
            next: page < lastPage ? page + 1 : lastPage,
          },
        });
      }, 500);
    });
  }
}

class Api extends Sync {
  constructor() {
    super();
    this.api = "/ap/v1/histories/";
  }

  /**
   * 解析結果一覧
   *
   * @param {number} page 表示するページ番号
   * @param {number} limit 最大表示件数
   * @param {string} start_date 解析実行期間　開始
   * @param {string} end_date 解析実行期間　終了
   * @param {string} min_length 最高文字一致数　（下限）
   * @param {string} min_ratio 最高一致率　（下限）
   * @param {string} similarity 類似率　（下限）
   */
  requestAcceptHistories(
    page,
    limit,
    start_date,
    end_date,
    min_length,
    min_ratio,
    similarity
  ) {
    return this.post(this.api + "accept/", {
      page,
      limit,
      start_date,
      end_date,
      min_length,
      min_ratio,
      similarity,
    });
  }
}

const api = window.__ENABLE_MOCK__ ? new Mock() : new Api();

export { AcceptService, Accept, SearchParam, api };
